import { IonCardHeader, IonCardTitle, IonCol, IonGrid, IonIcon, IonRow, IonText } from '@ionic/react';
import { buildOutline } from 'ionicons/icons';
import { ClockingDirection } from '../../../models/dms/clocking.model';
import { useAppSelector } from '../../../store/hooks';
import LabourTimer from '../../labourTimer/LabourTimer';

interface IComponentProps {
  simpleType?: boolean;
  allowRipple?: boolean;
  handleClick?: () => void;
}

const LabourClockingCardHeader: React.FC<IComponentProps> = ({ handleClick, simpleType = false, allowRipple = true, }) => {
  const { labourClocking } = useAppSelector(state => state.technicianClocking);

  return (
    (() => {
      switch (labourClocking?.direction) {
        case ClockingDirection.On:
          return <IonCardHeader className={simpleType ? 'ion-no-padding' : ''}>
            <IonGrid className="ion-no-margin">
              <IonRow>
                <IonCol>
                  <div className="flexed">
                    <IonIcon icon={buildOutline} size="large" className="title-icon" color="medium" />
                    {!simpleType && <div className="flexed-fill">
                      <div className="flexed col ion-next-nowrap">
                        <IonCardTitle class="flexed">Labour</IonCardTitle>
                        {/* <div className="ion-next-nowrap">
                          <IonIcon icon={''} />
                        </div> */}
                      </div>
                    </div>}
                  </div>
                </IonCol>
                <IonCol className="ion-text-end">
                  <LabourTimer />
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonCardHeader>;
        case ClockingDirection.Break:
          return <IonCardHeader className={simpleType ? 'ion-no-padding' : ''}>
            <IonGrid className="ion-no-margin">
              <IonRow>
                <IonCol>
                  <div className="flexed">
                    <IonIcon icon={buildOutline} size="large" className="title-icon" color="medium" />
                    {!simpleType && <div className="flexed-fill">
                      <div className="flexed col ion-next-nowrap">
                        <IonCardTitle class="flexed">Labour</IonCardTitle>
                        {/* <div className="ion-next-nowrap">
                          <IonIcon icon={''} />
                        </div> */}
                      </div>
                    </div>}
                  </div>
                </IonCol>
                <IonCol className="ion-text-end">
                  <LabourTimer />
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonCardHeader>;
        default:
          return <IonCardHeader className={simpleType ? 'ion-no-padding' : ''}>
            <IonGrid className="ion-no-margin">
              <IonRow>
                <IonCol>
                  <div className="flexed">
                    <IonIcon icon={buildOutline} size="large" className="title-icon" color="medium" />
                    {!simpleType && <div className="flexed-fill">
                      <div className="flexed col ion-next-nowrap">
                        <IonCardTitle class="flexed">Labour</IonCardTitle>
                        {/* <div className="ion-next-nowrap">
                          <IonIcon icon={''} />
                        </div> */}
                      </div>
                    </div>}
                  </div>
                </IonCol>
                <IonCol className="ion-text-end">
                  <IonText color="medium" className="ion-text-nowrap">
                    <h1 className="time-duration ion-no-margin">00:00</h1>
                    <h1 className="time-duration time-duration-seconds ion-no-margin">00</h1>
                  </IonText>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonCardHeader>;
      }
    })()
  );
};

export default LabourClockingCardHeader;
